import * as React from "react";
import { Query, graphql } from "react-apollo";
import { Row, Col, Button } from "reactstrap";
import * as uuid from "uuid";
import * as moment from "moment";
import { MdRemoveRedEye, MdCancel } from "react-icons/md";

// GraphQL
import GetCompanyRequests from "../../GraphQL/Queries/GetCompanyRequests";
import UpdateRequest from "../../GraphQL/Mutations/UpdateRequest";

// Presentation/UI
import Loader from "../../Components/Loader/DotLoader";
import Table from "../../Components/Table";
import GlobalModal from "../../Components/GlobalModal";
import DialogModal from "../../Components/DialogModal";

import EditRequestForm from "./EditRequestForm";

// Utils
import { orderDatasetByDateDesc } from "../../Utils/Helpers";

interface IProps {
  companyId: string;
  toastManager: any;
  mutate: any;
}

class AllRequests extends React.Component<IProps> {
  state = {
    modal: false,
    dialogModal: false,
    loading: false,
    title: "Are you sure you want to reject this request?",
    request: {},
    requestId: null
  };

  // Close dialog modal
  closeDialogModal = (): void => {
    this.setState({
      dialogModal: false
    });
  };

  // Open dialog modal
  openDialogModal = (companyRequest: any): void => {
    const requestId = !companyRequest ? null : companyRequest.id;
    this.setState({
      dialogModal: true,
      requestId
    });
  };

  // Handle response
  handleResponse = (e: React.FormEvent<HTMLInputElement>): void => {
    e.preventDefault();
    this.setState({ loading: true });
    // reject request mutation
    const { companyId } = this.props;
    this.props
      .mutate({
        variables: {
          id: this.state.requestId,
          status: "REJECT"
        },
        refetchQueries: [
          {
            query: GetCompanyRequests,
            variables: { id: companyId }
          }
        ]
      })
      .then((res: any) => {
        this.setState({ loading: false, requestId: null });
        this.closeDialogModal();
        this.toastNotification("Request has been rejected");
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  // Close modal
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  // Open modal
  openModal = (request: object): void => {
    this.setState({
      modal: true,
      request
    });
  };

  // success notification
  toastNotification = (message: string) => {
    this.props.toastManager.add(message, {
      appearance: "success",
      autoDismiss: true
    });
  };

  // Return priority
  returnPriority = (word: string): string => {
    switch (word) {
      case "HIGH":
        return "High";
      case "MEDIUM":
        return "Medium";
      case "LOW":
        return "Low";
      case "NONE":
        return "none";
      default:
        return "none";
    }
  };

  // Return status
  returnStatus = (word: string): string => {
    switch (word) {
      case "ACCEPT":
        return "Accepted";
      case "REJECT":
        return "Rejected";
      case "NONE":
        return "None";
      default:
        return "None";
    }
  };

  render() {
    const { request } = this.state;
    const { companyId } = this.props;
    return (
      <Query query={GetCompanyRequests} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the reqests</div>;
          }

          let requests = data.allRequests;
          requests = orderDatasetByDateDesc(requests);

          return (
            <Row>
              <GlobalModal
                toggleModal={this.closeModal}
                title="View Request"
                modalDisplay={
                  <EditRequestForm
                    notification={this.toastNotification}
                    closeModal={this.closeModal}
                    companyId={companyId}
                    request={request}
                  />
                }
                modal={this.state.modal}
              />
              <DialogModal
                modal={this.state.dialogModal}
                title={this.state.title}
                loading={this.state.loading}
                toggleModal={this.closeDialogModal}
                handleResponse={this.handleResponse}
              />
              <Col xs={12} md={12} lg={12}>
                <Table
                  data={requests}
                  columns={[
                    {
                      Header: "ID",
                      accessor: "id",
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Customer",
                      accessor: (companyRequest: any) => {
                        return companyRequest.customer.name;
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Date Of Request",
                      accessor: (companyRequest: any) => {
                        return moment(companyRequest.createdAt).format(
                          "DD/MM/YYYY"
                        );
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Time Of Request",
                      accessor: (companyRequest: any) => {
                        return moment(companyRequest.createdAt).format("LT");
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Title",
                      accessor: "title",
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Priority",
                      accessor: (companyRequest: any) => {
                        return this.returnPriority(companyRequest.priority);
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Status",
                      accessor: (companyRequest: any) => {
                        return this.returnStatus(companyRequest.status);
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companyRequest: object) => {
                        return (
                          <Button
                            onClick={() => this.openModal(companyRequest)}
                            className="icon-btn icon-edit-btn"
                          >
                            <MdRemoveRedEye color="#fff" size="1.35em" />
                          </Button>
                        );
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companyRequest: any) => {
                        return companyRequest.status === "NONE" ||
                          !companyRequest.status ? (
                          <Button
                            onClick={() => this.openDialogModal(companyRequest)}
                            className="icon-btn icon-delete-btn"
                          >
                            <MdCancel color="#fff" size="1.35em" />
                          </Button>
                        ) : null;
                      },
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={5}
                  showPaginationTop={false}
                  showPaginationBottom={true}
                />
              </Col>
            </Row>
          );
        }}
      </Query>
    );
  }
}

export default graphql<any, Response, any, any>(UpdateRequest)(AllRequests);



// WEBPACK FOOTER //
// ./src/Containers/Requests/AllRequests.tsx